// extracted by mini-css-extract-plugin
export default {"boldText":"HeroText_boldText__oEtnd","link":"HeroText_link__qkDzL","text":"HeroText_text__0ksS0"};